import { IPartnerMissedContactsView } from 'clickNgo/models/crud/views'

import { IPartnerMissedContacts } from '../../models/contacts'

export const mapPartnerMissedContacts = (
  data: IPartnerMissedContactsView
): IPartnerMissedContacts => ({
  partnerId: data.PartnerId,
  missedRoles: data.MissedRoles?.split(', ') || [],
})
